import styled from 'styled-components';

export const Signature = styled.img`
  width: 100px !important;
  height: 50px;
  background-color: #fff;
`;
